export const translations = {
  el: {
    nav: {
      home: "Αρχική",
      about: "Σχετικά",
      products: "Προϊόντα",
      services: "Υπηρεσίες",
      gallery: "Έργα",
      process: "Διαδικασία",
      contact: "Επικοινωνία",
      quote: "Ζητήστε Προσφορά",
    },
    hero: {
      eyebrow: "Πρώτες ύλες ξυλείας · Από το 2010",
      title1: "Ξυλεία",
      title2: "κομμένη",
      title3: "στα μέτρα σας",
      subtitle:
        "Πλάκες, πατώματα, decking, μασίφ ξύλο, καπλαμάδες και λάδια — όλα τα υλικά για την κατασκευή ή την ανακαίνισή σας, κομμένα και προετοιμασμένα ακριβώς όπως τα θέλετε.",
      ctaPrimary: "Ζητήστε Προσφορά",
      ctaSecondary: "Δείτε τα προϊόντα",
    },
    marquee: ["Δρυς", "Καρυδιά", "Καστανιά", "Οξιά", "Τικ", "Μπαμπού", "Έλατο", "MDF", "Κόντρα πλακέ", "Καπλαμάς", "Καδρόνια", "Τάβλες", "Δοκάρια", "Μαδέρια"],
    about: {
      eyebrow: "Σχετικά με εμάς",
      title1: "Πρώτη ύλη υψηλής",
      title2: "ποιότητας",
      p1: "Στη D Design Creations Carpentry προμηθεύουμε επαγγελματίες ξυλουργούς, αρχιτέκτονες, μάστορες αλλά και ιδιώτες με ξυλεία υψηλής ποιότητας — από επώνυμους κατασκευαστές της Ευρώπης.",
      p2: "Διαθέτουμε ένα πλήρες εύρος υλικών για κάθε κατασκευή ή ανακαίνιση: πλάκες, δάπεδα, decking, δομική ξυλεία, μασίφ ξύλα, καπλαμάδες, λάδια και φινιρίσματα. Όλα κόβονται και προετοιμάζονται ακριβώς στις διαστάσεις σας.",
      bullet1: "Πιστοποιημένη ξυλεία FSC",
      bullet2: "Κοπή με ακρίβεια χιλιοστού",
      bullet3: "Παράδοση Ελλάδα & εξωτερικό",
      bullet4: "Συμβουλευτική από ειδικούς",
      statBig: "15+",
      statLbl: "Χρόνια Εμπειρίας",
    },
    products: {
      eyebrow: "Κατηγορίες προϊόντων",
      title1: "Το πλήρες",
      title2: "εύρος ξυλείας",
      subtitle:
        "Ό,τι μπορεί να φτιαχτεί από ξύλο — το έχουμε. Από μασίφ δρυ μέχρι σύγχρονες σύνθετες πλάκες, όλα ως πρώτη ύλη ή έτοιμα κομμένα στις διαστάσεις σας.",
      items: [
        { name: "Πλάκες & Πανέλα", desc: "MDF, μοριοσανίδες (νοβοπάν), κόντρα πλακέ, OSB, θαλάσσης, μελαμίνες και διακοσμητικά πάνελ σε εκατοντάδες αποχρώσεις." },
        { name: "Πατώματα", desc: "Παρκέ μασίφ, ημιμασίφ, πολλαπλών στρώσεων, laminate και τεχνητά παρκέ από κορυφαίους κατασκευαστές της Ευρώπης." },
        { name: "Decking", desc: "Εξωτερικά ξύλινα δάπεδα από τικ, ιρόκο, μπαμπού, θερμοξυλεία και WPC για βεράντες, κήπους και πισίνες." },
        { name: "Όψεις & Επενδύσεις", desc: "Ξύλινες επενδύσεις τοίχων, ταβανιών και προσόψεων, σήτες αερισμού, βεντουρές — για εσωτερικό και εξωτερικό." },
        { name: "Δομική Ξυλεία", desc: "Καδρόνια για στέγες & οικοδομές, δοκάρια, τάβλες, μαδέρια, στρωτά, ξύλα στεγών — όλα τα δομικά ξύλα για κάθε κατασκευή." },
        { name: "Λάδια & Φινιρίσματα", desc: "Προστατευτικά λάδια, βερνίκια, λούστρα, κεριά και αδιαβροχοποιήσεις για κάθε τύπο ξύλου και εφαρμογή." },
        { name: "Μασίφ Ξύλο", desc: "Σανίδες, μαδέρια, πλάκες και κορμοί από δρυ, καρυδιά, καστανιά, οξιά, κερασιά, φλαμουριά και άλλα είδη." },
        { name: "Καπλαμάδες", desc: "Φυσικά και τεχνητά φύλλα ξύλου, εξωτικές υφές, edge banding — σε εκατοντάδες αποχρώσεις και πάχη." },
        { name: "Καδρόνια & Στύλοι", desc: "Καδρόνια τετράγωνα χοντρά και στρογγυλοί ξύλινοι στύλοι — όπως αυτοί που στηρίζουν τις μεγάλες ομπρέλες της παραλίας. Ιδανικά για πέργκολες, στέγαστρα, υπόστεγα κήπου και κατασκευές εξωτερικού χώρου." },
      ],
      cta: "Δείτε όλη τη γκάμα",
    },
    services: {
      eyebrow: "Οι υπηρεσίες μας",
      title1: "Όχι μόνο",
      title2: "ξυλεία",
      subtitle: "Φέρνουμε το υλικό έτοιμο για χρήση στο εργοτάξιο ή στο εργαστήριό σας.",
      items: [
        { num: "01", title: "Κοπή στις διαστάσεις σας", desc: "Πλάκες και ξύλα κομμένα με CNC ακρίβεια στις δικές σας διαστάσεις. Στείλτε μας λίστα — έχουμε το υλικό έτοιμο." },
        { num: "02", title: "Συμβουλευτική & επιλογή υλικών", desc: "Δεν ξέρετε ποιο υλικό ταιριάζει; Οι ειδικοί μας θα σας προτείνουν τη σωστή λύση για το έργο σας." },
        { num: "03", title: "Παράδοση Ελλάδα & εξωτερικό", desc: "Παραδίδουμε σε όλη την Ελλάδα με ειδικό εξοπλισμό. Για παραγγελίες εξωτερικού, αναλαμβάνουμε την αποστολή με μεταφορική επιλογής σας — τα μεταφορικά καλύπτονται από τον πελάτη." },
        { num: "04", title: "Εργαστήριο μεταποίησης", desc: "Φρεζάρισμα, τρύπες, ακμές, λούστρα και ειδικές επεξεργασίες σύμφωνα με τα σχέδιά σας." },
      ],
    },
    gallery: {
      eyebrow: "Επιλεγμένα έργα",
      title1: "Έργα",
      title2: "πελατών μας",
      subtitle: "Παραδείγματα από εφαρμογές και κατασκευές με τα υλικά μας.",
      categories: {
        all: "Όλα",
        flooring: "Πατώματα",
        decking: "Decking",
        panels: "Πλάκες",
        solid: "Μασίφ",
      },
      captions: {
        kitchenIsland: { name: "Κουζίνα με νησίδα", cat: "Πλάκες" },
        luxurySauna: { name: "Πολυτελής σάουνα", cat: "Έπιπλα Wellness" },
        luxuryPool: { name: "Πισίνα με ξύλινο deck", cat: "Decking" },
        modernKitchen: { name: "Μοντέρνα κουζίνα", cat: "Πλάκες" },
        timberStack: { name: "Επιλεγμένη ξυλεία", cat: "Μασίφ" },
        oakFurniture: { name: "Έπιπλο μασίφ δρυ", cat: "Μασίφ" },
        outdoorSpa: { name: "Εξωτερική πισίνα · Spa", cat: "Decking" },
        outdoorDeck: { name: "Εξωτερικό decking", cat: "Decking" },
      },
    },
    process: {
      eyebrow: "Πώς δουλεύουμε",
      title1: "Από την παραγγελία",
      title2: "στην παράδοση",
      subtitle: "Τέσσερα απλά βήματα για να έχετε το υλικό σας έτοιμο.",
      steps: [
        { name: "Αίτημα", desc: "Στείλτε μας σχέδια, διαστάσεις ή απλώς την ιδέα σας — απαντάμε εντός 24 ωρών." },
        { name: "Προσφορά", desc: "Σας προτείνουμε υλικά, τιμές και τρόπο επεξεργασίας. Διαφανής τιμολόγηση." },
        { name: "Παραγωγή & κοπή", desc: "Κόβουμε και προετοιμάζουμε την ξυλεία σύμφωνα με τη λίστα σας." },
        { name: "Παράδοση", desc: "Παραδίδουμε στο σημείο που μας πείτε με ειδικό εξοπλισμό." },
      ],
    },
    contact: {
      eyebrow: "Επικοινωνία",
      title1: "Πείτε μας τι",
      title2: "χρειάζεστε",
      subtitle: "Στείλτε τη λίστα υλικών ή τα σχέδιά σας. Θα σας απαντήσουμε εντός 24 ωρών — ή καλέστε μας απευθείας.",
      name: "Ονοματεπώνυμο",
      email: "Email",
      phone: "Τηλέφωνο",
      subject: "Θέμα",
      message: "Λίστα υλικών / Μήνυμα",
      send: "Αποστολή Αιτήματος",
      sending: "Αποστολή...",
      success: "Ευχαριστούμε! Θα επικοινωνήσουμε σύντομα.",
      error: "Παρουσιάστηκε σφάλμα. Δοκιμάστε ξανά.",
      phoneLabel: "Τηλέφωνο",
      emailLabel: "Email",
      hours: "Δευτέρα – Σάββατο · 09:00 – 18:00",
      hoursLabel: "Ωράριο",
    },
    footer: {
      brand1: "Πρώτες ύλες ξυλείας,",
      brand2: "για κάθε κατασκευή.",
      tagline: "Πλάκες, πατώματα, decking, μασίφ ξύλα και υλικά φινιρίσματος — κομμένα στα μέτρα σας.",
      rights: "Με επιφύλαξη παντός δικαιώματος.",
      quick: "Πλοήγηση",
      reach: "Επικοινωνία",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      products: "Products",
      services: "Services",
      gallery: "Work",
      process: "How",
      contact: "Contact",
      quote: "Request a Quote",
    },
    hero: {
      eyebrow: "Premium timber supplier · Since 2010",
      title1: "Timber",
      title2: "cut",
      title3: "to your size",
      subtitle:
        "Panels, flooring, decking, solid wood, veneers and oils — everything you need for construction or renovation, cut and prepared exactly the way you want it.",
      ctaPrimary: "Request a Quote",
      ctaSecondary: "Browse products",
    },
    marquee: ["Oak", "Walnut", "Chestnut", "Beech", "Teak", "Bamboo", "Spruce", "MDF", "Plywood", "Veneer", "Roof battens", "Planks", "Beams", "Joists"],
    about: {
      eyebrow: "About us",
      title1: "Premium raw",
      title2: "materials",
      p1: "At D Design Creations Carpentry we supply professional carpenters, architects, builders and homeowners with high-quality timber — sourced from leading European manufacturers.",
      p2: "We carry a complete range for any construction or renovation: panels, flooring, decking, structural timber, solid wood, veneers, oils and finishes. Everything cut and prepared precisely to your dimensions.",
      bullet1: "FSC certified timber",
      bullet2: "Millimeter-precise cutting",
      bullet3: "Delivery in Greece & abroad",
      bullet4: "Expert consultation",
      statBig: "15+",
      statLbl: "Years of Experience",
    },
    products: {
      eyebrow: "Product categories",
      title1: "The full",
      title2: "timber range",
      subtitle:
        "Anything that can be made from timber — we have it. From solid oak to engineered panels, supplied raw or cut to your dimensions.",
      items: [
        { name: "Panels & Boards", desc: "MDF, particle board (chipboard), plywood, OSB, marine plywood, melamine and decorative panels in hundreds of finishes." },
        { name: "Flooring", desc: "Solid hardwood, engineered, multi-layer parquet, laminate and synthetic flooring from leading European manufacturers." },
        { name: "Decking", desc: "Outdoor wood flooring in teak, iroko, bamboo, thermo-wood and WPC for terraces, gardens and pool areas." },
        { name: "Facade & Cladding", desc: "Wooden wall, ceiling and facade cladding, ventilation grilles and louvers — for indoor and outdoor use." },
        { name: "Structural Timber", desc: "Roof battens & joists, beams, planks, board lumber, structural framing — every structural timber for any build." },
        { name: "Oils & Finishes", desc: "Protective oils, varnishes, lacquers, waxes and waterproofing for every type of wood and application." },
        { name: "Solid Wood", desc: "Boards, planks, slabs and logs in oak, walnut, chestnut, beech, cherry, linden and many more species." },
        { name: "Veneers", desc: "Natural and engineered wood veneer sheets, exotic textures, edge banding — in hundreds of finishes and thicknesses." },
        { name: "Battens & Posts", desc: "Heavy-duty square battens and round wooden posts — like those supporting large beach umbrellas. Perfect for pergolas, canopies, gazebos and outdoor structures." },
      ],
      cta: "See the full range",
    },
    services: {
      eyebrow: "Our services",
      title1: "More than",
      title2: "just timber",
      subtitle: "We deliver material ready-to-use to your job site or workshop.",
      items: [
        { num: "01", title: "Cut to your dimensions", desc: "Panels and timber cut with CNC precision to your measurements. Send us a list — we'll have it ready." },
        { num: "02", title: "Consultation & material selection", desc: "Not sure which material fits? Our experts will recommend the right solution for your project." },
        { num: "03", title: "Delivery in Greece & abroad", desc: "We deliver across Greece with specialized equipment. For international orders, we arrange shipping with your chosen carrier — shipping costs are covered by the customer." },
        { num: "04", title: "Processing workshop", desc: "Routing, drilling, edge banding, finishing and special treatments according to your plans." },
      ],
    },
    gallery: {
      eyebrow: "Selected projects",
      title1: "Customer",
      title2: "projects",
      subtitle: "Examples of applications and builds using our materials.",
      categories: {
        all: "All",
        flooring: "Flooring",
        decking: "Decking",
        panels: "Panels",
        solid: "Solid",
      },
      captions: {
        kitchenIsland: { name: "Kitchen with island", cat: "Panels" },
        luxurySauna: { name: "Luxury wooden sauna", cat: "Wellness" },
        luxuryPool: { name: "Pool with wood deck", cat: "Decking" },
        modernKitchen: { name: "Modern kitchen", cat: "Panels" },
        timberStack: { name: "Selected timber", cat: "Solid" },
        oakFurniture: { name: "Solid oak furniture", cat: "Solid" },
        outdoorSpa: { name: "Outdoor pool · Spa", cat: "Decking" },
        outdoorDeck: { name: "Outdoor decking", cat: "Decking" },
      },
    },
    process: {
      eyebrow: "How we work",
      title1: "From order",
      title2: "to delivery",
      subtitle: "Four simple steps to get your material ready.",
      steps: [
        { name: "Request", desc: "Send us drawings, dimensions or just your idea — we reply within 24 hours." },
        { name: "Quote", desc: "We suggest materials, prices and processing options. Transparent pricing." },
        { name: "Production & cutting", desc: "We cut and prepare the timber exactly to your list." },
        { name: "Delivery", desc: "We deliver to your chosen site with specialized equipment." },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title1: "Tell us what",
      title2: "you need",
      subtitle: "Send us your material list or drawings. We'll reply within 24 hours — or call us directly.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      subject: "Subject",
      message: "Material list / Message",
      send: "Send Request",
      sending: "Sending...",
      success: "Thank you! We'll be in touch shortly.",
      error: "Something went wrong. Please try again.",
      phoneLabel: "Phone",
      emailLabel: "Email",
      hours: "Monday – Saturday · 09:00 – 18:00",
      hoursLabel: "Hours",
    },
    footer: {
      brand1: "Timber raw materials,",
      brand2: "for every build.",
      tagline: "Panels, flooring, decking, solid wood and finishing materials — cut to your size.",
      rights: "All rights reserved.",
      quick: "Navigation",
      reach: "Reach Us",
    },
  },
  bg: {
    nav: {
      home: "Начало",
      about: "За нас",
      products: "Продукти",
      services: "Услуги",
      gallery: "Проекти",
      process: "Процес",
      contact: "Контакт",
      quote: "Поискай оферта",
    },
    hero: {
      eyebrow: "Премиум дървесина · От 2010",
      title1: "Дървен материал",
      title2: "по",
      title3: "вашите размери",
      subtitle:
        "Плоскости, подови настилки, декинг, масивна дървесина, фурнир и масла — всичко необходимо за строеж или ремонт, нарязано и подготвено точно както го искате.",
      ctaPrimary: "Поискай оферта",
      ctaSecondary: "Виж продуктите",
    },
    marquee: ["Дъб", "Орех", "Кестен", "Бук", "Тик", "Бамбук", "Смърч", "MDF", "Шперплат", "Фурнир", "Греди", "Дъски", "Талпи", "Мертеци"],
    about: {
      eyebrow: "За нас",
      title1: "Първокачествени",
      title2: "материали",
      p1: "В D Design Creations Carpentry доставяме професионални дърводелци, архитекти, строители и частни клиенти с висококачествена дървесина — от водещи европейски производители.",
      p2: "Имаме пълна гама материали за всяко строителство или ремонт: плоскости, подови настилки, декинг, конструктивна дървесина, масивни дървета, фурнир, масла и финиши. Всичко се нарязва и подготвя точно по вашите размери.",
      bullet1: "FSC сертифицирана дървесина",
      bullet2: "Рязане с милиметрова точност",
      bullet3: "Доставка в Гърция и чужбина",
      bullet4: "Експертна консултация",
      statBig: "15+",
      statLbl: "Години опит",
    },
    products: {
      eyebrow: "Категории продукти",
      title1: "Пълна",
      title2: "гама дървесина",
      subtitle:
        "Всичко, което може да се направи от дърво — го имаме. От масивен дъб до съвременни инженерни плоскости, доставено като суровина или нарязано по вашите размери.",
      items: [
        { name: "Плоскости и панели", desc: "MDF, ПДЧ (чипборд), шперплат, OSB, морски шперплат, меламин и декоративни панели в стотици нюанси." },
        { name: "Подови настилки", desc: "Масивен паркет, инженерен, многослоен паркет, ламинат и синтетични подове от водещи европейски производители." },
        { name: "Декинг", desc: "Външни дървени подове от тик, ироко, бамбук, термодървесина и WPC за тераси, градини и басейни." },
        { name: "Фасади и обшивки", desc: "Дървени обшивки за стени, тавани и фасади, вентилационни решетки — за вътрешно и външно ползване." },
        { name: "Конструктивна дървесина", desc: "Мертеци за покриви и строежи, греди, дъски, талпи, конструктивни елементи — всичко за всеки строеж." },
        { name: "Масла и финиши", desc: "Защитни масла, лакове, восъци и хидроизолация за всеки тип дърво и приложение." },
        { name: "Масивна дървесина", desc: "Дъски, талпи, плочи и трупи от дъб, орех, кестен, бук, череша, липа и много други видове." },
        { name: "Фурнир", desc: "Натурален и инженерен фурнир, екзотични текстури, кантиращи ленти — в стотици нюанси и дебелини." },
        { name: "Греди и стълбове", desc: "Дебели квадратни греди и кръгли дървени стълбове — като тези, които поддържат големите плажни чадъри. Идеални за перголи, навеси, беседки и градински конструкции." },
      ],
      cta: "Виж цялата гама",
    },
    services: {
      eyebrow: "Нашите услуги",
      title1: "Повече от",
      title2: "просто дървесина",
      subtitle: "Доставяме материал готов за употреба до вашия обект или работилница.",
      items: [
        { num: "01", title: "Рязане по вашите размери", desc: "Плоскости и дървесина, нарязани с CNC точност по вашите размери. Изпратете списък — материалът е готов." },
        { num: "02", title: "Консултация и избор на материали", desc: "Не сте сигурни какъв материал е подходящ? Нашите експерти ще препоръчат правилното решение за вашия проект." },
        { num: "03", title: "Доставка в Гърция и чужбина", desc: "Доставяме в цяла Гърция със специализирано оборудване. За поръчки в чужбина организираме доставка с избран от вас превозвач — транспортните разходи са за сметка на клиента." },
        { num: "04", title: "Работилница за преработка", desc: "Фрезоване, пробиване, кантиране, финиш и специални обработки по вашите чертежи." },
      ],
    },
    gallery: {
      eyebrow: "Избрани проекти",
      title1: "Клиентски",
      title2: "проекти",
      subtitle: "Примери от приложения и конструкции с нашите материали.",
      categories: {
        all: "Всички",
        flooring: "Подови",
        decking: "Декинг",
        panels: "Плоскости",
        solid: "Масивно",
      },
      captions: {
        kitchenIsland: { name: "Кухня с остров", cat: "Плоскости" },
        luxurySauna: { name: "Луксозна дървена сауна", cat: "Уелнес" },
        luxuryPool: { name: "Басейн с дървен декинг", cat: "Декинг" },
        modernKitchen: { name: "Модерна кухня", cat: "Плоскости" },
        timberStack: { name: "Избрана дървесина", cat: "Масивно" },
        oakFurniture: { name: "Масивно дъбово обзавеждане", cat: "Масивно" },
        outdoorSpa: { name: "Външен басейн · Спа", cat: "Декинг" },
        outdoorDeck: { name: "Външен декинг", cat: "Декинг" },
      },
    },
    process: {
      eyebrow: "Как работим",
      title1: "От поръчка",
      title2: "до доставка",
      subtitle: "Четири прости стъпки да получите материала готов.",
      steps: [
        { name: "Заявка", desc: "Изпратете чертежи, размери или просто идеята си — отговаряме до 24 часа." },
        { name: "Оферта", desc: "Предлагаме материали, цени и опции за обработка. Прозрачно ценообразуване." },
        { name: "Производство и рязане", desc: "Нарязваме и подготвяме дървесината точно по вашия списък." },
        { name: "Доставка", desc: "Доставяме до избраното от вас място със специализирано оборудване." },
      ],
    },
    contact: {
      eyebrow: "Контакт",
      title1: "Кажете ни от какво",
      title2: "имате нужда",
      subtitle: "Изпратете списъка с материали или чертежи. Ще отговорим в рамките на 24 часа — или ни се обадете директно.",
      name: "Пълно име",
      email: "Email",
      phone: "Телефон",
      subject: "Тема",
      message: "Списък материали / Съобщение",
      send: "Изпрати запитване",
      sending: "Изпращане...",
      success: "Благодарим! Ще се свържем скоро.",
      error: "Възникна грешка. Опитайте отново.",
      phoneLabel: "Телефон",
      emailLabel: "Email",
      hours: "Понеделник – Събота · 09:00 – 18:00",
      hoursLabel: "Работно време",
    },
    footer: {
      brand1: "Дървени материали,",
      brand2: "за всеки строеж.",
      tagline: "Плоскости, подови настилки, декинг, масивна дървесина и финишни материали — нарязани по вашите размери.",
      rights: "Всички права запазени.",
      quick: "Навигация",
      reach: "Връзка с нас",
    },
  },
};

export const CONTACT_INFO = {
  phone: "+30 6949791000",
  phoneRaw: "+306949791000",
  email: "ddesigncreationscarpentry@gmail.com",
  brand: "D Design Creations Carpentry",
  brandShort: "D Design",
  brandSub: "Creations · Carpentry",
};

/* All images are royalty-free wood/carpentry photography (Unsplash + Pexels) — no third-party logos */
export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1601058268499-e52658b8bb88?w=1200&q=85",
  aboutMain: "https://images.pexels.com/photos/129722/pexels-photo-129722.jpeg?auto=compress&w=1100",
  aboutSub: "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=900&q=85",
  woodLogo: "https://customer-assets.emergentagent.com/job_ui-screenshot-3/artifacts/2w4thyfz_ChatGPT%20Image%2015%20%CE%99%CE%BF%CF%85%CE%BD%202026%2C%2002_12_13%20%CE%BC.%CE%BC..png",
  woodLogoEl: "https://customer-assets.emergentagent.com/job_ui-screenshot-3/artifacts/redach2o_ChatGPT%20Image%2015%20%CE%99%CE%BF%CF%85%CE%BD%202026%2C%2002_16_47%20%CE%BC.%CE%BC..png",
  bannerEl: "https://customer-assets.emergentagent.com/job_ui-screenshot-3/artifacts/7xxtaehj_ChatGPT%20Image%2015%20%CE%99%CE%BF%CF%85%CE%BD%202026%2C%2002_38_32%20%CE%BC.%CE%BC..png",
};

export const PRODUCT_IMAGES = [
  "https://images.pexels.com/photos/129728/pexels-photo-129728.jpeg?auto=compress&w=900",  // 01 Plates & Panels (smooth wood panel)
  "https://images.pexels.com/photos/139309/pexels-photo-139309.jpeg?auto=compress&w=900",  // 02 Flooring (parquet planks)
  "https://images.pexels.com/photos/326311/pexels-photo-326311.jpeg?auto=compress&w=900",  // 03 Decking (dark deck planks)
  "https://images.pexels.com/photos/129729/pexels-photo-129729.jpeg?auto=compress&w=900",  // 04 Facade & Cladding (dark vertical wood)
  "https://images.pexels.com/photos/2098624/pexels-photo-2098624.jpeg?auto=compress&w=900", // 05 Structural Timber (wood construction frame)
  "https://images.pexels.com/photos/139308/pexels-photo-139308.jpeg?auto=compress&w=900",  // 06 Oils & Finishes (golden oiled wood)
  "https://images.pexels.com/photos/172290/pexels-photo-172290.jpeg?auto=compress&w=900",  // 07 Solid Wood (tree rings cross-section)
  "https://images.pexels.com/photos/172291/pexels-photo-172291.jpeg?auto=compress&w=900",  // 08 Veneer (horizontal wood planks)
  "https://images.pexels.com/photos/235985/pexels-photo-235985.jpeg?auto=compress&w=900",  // 09 Battens & Posts (stacked wooden timber posts)
];

export const GALLERY = [
  { key: "kitchenIsland",  src: "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=1200&q=85", cat: "panels",   cls: "gi-1" },
  { key: "luxurySauna",    src: "https://images.unsplash.com/photo-1583416750470-965b2707b355?w=1100&q=85", cat: "panels",   cls: "gi-2" },
  { key: "luxuryPool",     src: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=1000&q=85", cat: "decking",  cls: "gi-3" },
  { key: "modernKitchen",  src: "https://images.unsplash.com/photo-1556909172-54557c7e4fb7?w=1000&q=85",   cat: "panels",   cls: "gi-4" },
  { key: "timberStack",    src: "https://images.pexels.com/photos/129733/pexels-photo-129733.jpeg?auto=compress&w=900",   cat: "solid",    cls: "gi-5" },
  { key: "oakFurniture",   src: "https://images.pexels.com/photos/172276/pexels-photo-172276.jpeg?auto=compress&w=1100",   cat: "solid",    cls: "gi-6" },
  { key: "outdoorSpa",     src: "https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=900&q=85",  cat: "decking",  cls: "gi-7" },
  { key: "outdoorDeck",    src: "https://images.pexels.com/photos/326311/pexels-photo-326311.jpeg?auto=compress&w=1000",   cat: "decking",  cls: "gi-8" },
];
